const s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Less Than or Equal Icon</title><desc>A picture showing the lass-than or equal symbol.</desc><path d="M5.99 19h12.02v2H5.99zM18 14.9L8.91 10 18 5.11V3L6 9.47v1.07l12 6.47V14.9z"/></svg>';
export {
  s as default
};
